import { Link } from '@ecomm/framework'
import { useEnv } from '@ecomm/utils'
import classNames from 'classnames'
import { format, parse } from 'date-fns'
import React from 'react'

import { ApolloRichText } from '@ecomm/contentful/components'
import { useReviewSectionQuery } from './useReviewSectionQuery'

// NOTE: This component is currently used only in /hell page, which has an old layout version.
// For its possible deletion or change in the future, I'm leaving this note to re-evaluate this component existence at that moment.
export function ReviewSection({ id }: { readonly id: string }) {
  const { locale } = useEnv()
  const parseFormat = locale === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'

  const {
    button,
    headline,
    reviewsCollection: { items }
  } = useReviewSectionQuery(id)

  return (
    <section>
      {headline ? <h2 className="w-full text-center">{headline}</h2> : null}
      <ul className="grid w-full list-none grid-cols-12 gap-4 p-0 md:gap-8">
        {items.map(review => (
          <li
            className={classNames(
              'rounded-base bg-neutral-light-50 col-span-12 m-0 flex h-full flex-col justify-center px-8 py-6 text-center lg:px-12 lg:py-8',
              {
                'md:col-span-6': items.length === 2,
                'md:col-span-4': items.length > 2,
                'lg:col-span-3': items.length > 3
              }
            )}
            key={`Review-${review.company}`}
          >
            <span className="text-heading-4-size mt-0 font-light">
              <ApolloRichText {...review.review} />
            </span>
            <p className="mb-1 mt-0 font-bold">{review.company}</p>
            {!!review.publishDate ? (
              <span className="text-base">
                {format(
                  parse(
                    review.publishDate.slice(0, 10),
                    'yyyy-MM-dd',
                    new Date()
                  ),
                  parseFormat
                )}
              </span>
            ) : null}
          </li>
        ))}
      </ul>
      {button ? (
        <Link
          className="btn btn-solid-primary mx-auto mt-8 block w-full md:w-fit"
          to={button.url}
        >
          {button.text}
        </Link>
      ) : null}
    </section>
  )
}
